import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDW2YK57rO9mE_0qhexS3TF37QnNk1Z7VQ",
  authDomain: "company-shahn.firebaseapp.com",
  projectId: "company-shahn",
  storageBucket: "company-shahn.appspot.com",
  messagingSenderId: "124504458096",
  appId: "1:124504458096:web:ee7269fa6f6835d61185b5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

export { db };
